/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Kind_TeamInputs */



/**
* | output |
* | --- |
* | "Team meeting" |
*
* @param {Meeting_Kind_TeamInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_kind_team = /** @type {((inputs?: Meeting_Kind_TeamInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Kind_TeamInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Teammeeting")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réunion d'équipe")
	return /** @type {LocalizedString} */ ("Team meeting")
});